
import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Actions
import * as merchantAction from '../actions/components/merchant'
import * as getActiveTablesAction from '../actions/components/table'

class CollapseGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isExpand: props.expand,
    }
  }

  toggleCollapseIconButton = () => this.setState({ isExpand: !this.state.isExpand })

  renderCollapseGroup = () => {
    const {
      classes,
      title,
      children,
      onClick,
      expand,
    } = this.props

    const { isExpand } = this.state

    const collapseIconButton = isExpand
      ? <FontAwesomeIcon icon='chevron-up' />
      : <FontAwesomeIcon icon='chevron-down' />

    return (
      <React.Fragment>
        <div className={classes.collapse} onClick={() => onClick(title)}>
          {title}
          {collapseIconButton}
        </div>
        {expand && children}
      </React.Fragment>
    )
  }

  render () {
    return this.renderCollapseGroup()
  }
}

const styles = {
  collapse: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 32,
    padding: '8px 16px',
    fontSize: 16,
    fontWeight: 700,
    color: '#826e6b',
    backgroundColor: '#dbdbdb',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#ccc',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    activeTables: state.activeTables,
  }
}

const mapDispatchToProps = {
  getMerchant: merchantAction.getMerchant,
  getActiveTables: getActiveTablesAction.getActiveTables,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(CollapseGroup)



// WEBPACK FOOTER //
// ./src/components/CollapseGroup.jsx